import clsx from 'clsx';
import { Icon } from '../icon/icon.component';
import { OutlineCard } from '../outline-card/outline-card.component';
import { type Style, mergeStyle } from './metric-card.module.css';

interface Props {
  style?: Style;
  icon: string;
  label: string;
  value: string;
  color?: 'emerald' | 'blue' | 'red';
  loading?: boolean;
}

export function MetricCard(props: Props) {

  const {
    style: customStyle,
    icon,
    label,
    value,
    color = 'emerald',
    loading
  } = props;

  const style = mergeStyle(customStyle);

  return (
    <OutlineCard className={clsx(style.card, loading && style.loading)}>
      <div className={style.header}>
        <Icon icon={icon} className={clsx(style.icon, style[color])}/>
        <span className={style.label}>{label}</span>
      </div>
      <span className={style.value}>{value}</span>
    </OutlineCard>
  );
}
